import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import Control from "../../1. Core/Control";
import NP from "../../1. Core/NP";
import {Team} from "../types";
import {ServerAPI} from "../../1. Core/ServerAPI";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";

import Delegate from "../../1. Core/Delegate";
import EditTeamDialog from "./EditTeamDialog";
import Menu from "../../1. Core/Controls/Menu/Menu";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";
import UserTeamList from "./UserTeamList";
import {PageMode} from "../../10. Battle/types";
import AddUserToTeamDialog from "./AddUserToTeamDialog";
import PlayerRatingFilterPanel from "../../Admin/Users/PlayerRatingFilterPanel";


export default class TeamList extends Control {

    private EvShowPageModeClick: Delegate;
    private _dataTable: DataTable;
    private _dataWithFiltersNode: HTMLElement;
    private _drillDownPanel: UserTeamList;
    private _topAppBar: TopAppBar;
    private _filtersPanel: PlayerRatingFilterPanel;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this.EvShowPageModeClick = new Delegate();
        super._initFields(settings);
    }

    getTopAppBar() {
        return this._topAppBar;
    }

    _render() {
        this.np_render();
        this.addClass('');

        this._topAppBar = new TopAppBar({
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            Caption: 'Teams',
            ParentNode: this._root,
            ShowSearchButton: false,
            MainButton: {
                FontImage: NP.FontImages.menu,
                EvClick: () => this.EvShowPageModeClick.fire(this)
            },
            RightItems: NP.getCurrentUser().isBDAdmin() ? [
                new IconToggleButton({
                    FontImage: NP.FontImages.add,
                    EvClick: () => {

                        if (this._drillDownPanel) {
                            new AddUserToTeamDialog({
                                TeamId: this._drillDownPanel._TeamId,
                                EvOkButtonClick: () => this._drillDownPanel.refresh()
                            }).show();
                        } else
                            new EditTeamDialog({EvOkButtonClick: () => this.refreshList()}).show();
                    }
                }),
            ] : [],
            EvBackClick: () => {
                this._topAppBar.setCaption('Teams');
                NP.updateBrowserUrlString(true, PageMode.teams);
                NP.showNode(this._dataTable.getRoot());
                this._drillDownPanel.destroy();
                this._drillDownPanel = null;
                this._topAppBar.setShowBackButton(false)
                this._filtersPanel.setIsVisible(true)
            }
        });

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowSettingsButton: true,
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: false,
            EnableSort: false,
            ImageWidth: 32,
            Columns: [{
                Content: 'Id',
                Width: '10%',
                PropertyContent: 'id'
            }, {
                Content: NP.RM.getString('Title'),
                PropertyContent: 'name',
                Width: '60%'
            }, {
                Content: 'Is Open',
                PropertyContent: 'isOpen',
                Width: '10%'
            }, {
                Content: 'Total Coins',
                PropertyContent: 'coins_str',
                Width: '10%'
            }, {
                Content: NP.RM.getString('TotalDiamonds'),
                PropertyContent: 'pts_str',
                Width: '10%'
            }],
            EvItemClick: (s: object, e: { Item: Team }) => {
                this.showUsersList(e.Item)
                this._topAppBar.setCaption(e.Item.name);
            },
            ShowPaginator: false,
            EvItemContextMenu: async (s: any, e: { Event: any, Item: Team }) => {
                if (!NP.getCurrentUser().isBDAdmin())
                    return;

                let menu = new Menu({
                    Items: [{
                        FontImage: NP.FontImages.edit,
                        RK: 'Edit',
                        Value: 'Edit',
                    }, {
                        FontImage: NP.FontImages.delete,
                        RK: 'Remove',
                        Value: 'Remove',
                    }],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {

                        switch (event.Item.getValue()) {
                            case 'Edit':
                                new EditTeamDialog({
                                    Team: e.Item,
                                    EvOkButtonClick: () => this.refreshList()
                                }).show()
                                break
                            case 'Remove':
                                NP.showConfirm({
                                    Content: NP.RM.getString('AreYouS'),
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.callUiApi("/teams/" + e.Item.id, null, 'DELETE');
                                        this.refreshList();
                                    }
                                })
                                break
                        }


                    }
                });
                menu.showContextMenu(e.Event);
            }
        });

        this._filtersPanel = new PlayerRatingFilterPanel({
            ParentNode: this._dataWithFiltersNode,
            Width: 280,
            Height: this.getHeight(),
            EvFilterSortChanged: () => this.refresh()
        });

        this._filtersPanel.setIsVisible(true)

        this.refresh()
    }

    showUsersList(team: Team) {
        NP.updateBrowserUrlString(true, PageMode.teams, team.id);

        NP.hideNode(this._dataTable.getRoot());

        this._drillDownPanel = new UserTeamList({
            ParentNode: this._dataWithFiltersNode,
            Width: this._Width,
            Height: this._Height,
            TeamId: team.id,
        })

        this._topAppBar.setShowBackButton(true)
        this._drillDownPanel.setWidth(this._Width);
        this._filtersPanel.setIsVisible(false)
    }


    formatNum(value: number): string {
        if (value == null) return '';
        return new Intl.NumberFormat('en-US', {
            useGrouping: true,
        }).format(value);
    }

    setHeight(value: number) {
        super.setHeight(value);
        this._dataTable.setHeight(value);
        if (this._drillDownPanel)
            this._drillDownPanel.setHeight(value)

        this._filtersPanel.setHeight(value);
    }

    setWidth(value: number) {
        super.setWidth(value);
        if (this._filtersPanel.getIsVisible())
            value = value - 280;
        this._dataTable.setWidth(value);
        if (this._dataTable.getIsSmall()) {

            this.setHeight(this._Height);
        } else {

            this.setHeight(this._Height);
        }
        if (this._drillDownPanel)
            this._drillDownPanel.setWidth(value)
    }

    refresh() {
        this.refreshList();
    }

    private async refreshList() {
        let teams = await ServerAPI.post<Team[]>(`/teams/list`, {
            ...this._filtersPanel.getFilterData()
        })

        const rows = teams.map(it => ({
            ...it,
            pts_str: this.formatNum(it.pts),
            coins_str: this.formatNum(it.coins)
        }));

        this._dataTable.setRows(rows);
    }
}